// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"22234878","769":"678429f5"}[chunkId] + ".chunk.js";
};